import type {
  MRT_Column,
  MRT_RowData,
  MRT_TableInstance
} from "mantine-react-table-open";
import { HeaderWithWarning } from "../../../../../mantine/mrt/components/header/HeaderWithWarning";
import isColumnComplete from "../../../../../mantine/mrt/utils/isColumnComplete";
import { TruncatedHeader } from "../../../../../mantine/TruncatedHeader";

interface CustomTableHeaderProps<TData extends MRT_RowData> {
  column: MRT_Column<TData>;
  table: MRT_TableInstance<TData>;
}

function CustomTableHeader<TData extends MRT_RowData>({
  column,
  table
}: CustomTableHeaderProps<TData>) {
  const hasIncompleteDataWarning = !isColumnComplete(
    table,
    column.columnDef.accessorKey
  );
  if (hasIncompleteDataWarning) {
    return (
      <HeaderWithWarning
        column={column}
        label={
          "Bedeutung der “-”: Die Berechnung ist noch nicht möglich, da externe Daten fehlen (z. B. Netztransparenz, Börsenpreise, Ausfallarbeit). Sobald sie verfügbar und für Ihre Anlagen relevant sind, erfolgt die automatische Berechnung."
        }
      />
    );
  }
  return <TruncatedHeader>{column.columnDef.header}</TruncatedHeader>;
}

export { CustomTableHeader };
